<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.71515 6.3675C4.19265 -0.127498 13.8151 -0.119998 15.2851 6.375C16.1476 10.185 13.7776 13.41 11.7001 15.405C10.1926 16.86 7.80765 16.86 6.29265 15.405C4.22265 13.41 1.85265 10.1775 2.71515 6.3675Z" stroke="#302F2F" stroke-width="1.5"/>
    <path d="M6.9375 8.625L8.0625 9.75L11.0625 6.75" stroke="#302F2F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>